import { render } from "./PaymentInfoBox.vue?vue&type=template&id=4402979b"
import script from "./PaymentInfoBox.vue?vue&type=script&lang=js"
export * from "./PaymentInfoBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__